import type { DefaultTheme } from "styled-components";
import { toyotaTheme as toyotaThemeV1 } from "../../../common-deprecated/themes/toyotaTheme";
import { lexusTheme as lexusThemeV1 } from "../../../common-deprecated/themes/lexusTheme";
import { uscTheme as toyotaThemeV2 } from "./toyotaTheme";
import { uscTheme as lexusThemeV2 } from "./lexusTheme";
import type { CommonSettingsType } from "../../../common-deprecated/settings/fetchCommonSettings";
import { isLexus, isRTL } from "../../../common-deprecated/settings/utils/commonSettingUtils";

/**
 * Returns the USC V2 specific theme
 */
export const getUscV2Theme = (settings: CommonSettingsType): DefaultTheme => {
    const isRTLSetting = isRTL(settings);
    const isLexusSetting = isLexus(settings);
    const { noContainerSpacing } = settings.layoutOptions;

    return isLexusSetting
        ? { ...lexusThemeV1, ...lexusThemeV2, isRTL: isRTLSetting, noContainerSpacing }
        : { ...toyotaThemeV1, ...toyotaThemeV2, isRTL: isRTLSetting, noContainerSpacing };
};
